/* eslint-disable react/no-children-prop */
import React, { Fragment } from 'react';
import {
  Card, CardBody, Row, Col, ButtonToolbar,
} from 'reactstrap';
import { connect } from 'react-redux';


import { Tooltip } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import { Field, reduxForm, getFormValues, change } from 'redux-form';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';

import renderDropZoneField from './DropZone';
import RichTextEditor from "../../../shared/components/form/RichTextEditor";
import SaveAccountIcon from 'mdi-react/AccountCheckIcon';
import ResetAccountIcon from 'mdi-react/RefreshIcon';
import AccountIcon from 'mdi-react/AccountBoxIcon';

import { ThemeProvider } from '@material-ui/core/styles';
import{
	matTheme,
} from '../../../shared/helpers/utils';


const required = value => value ? undefined : 'Required'
const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined
const maxLength15 = maxLength(15)
const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined
const minValue = min => value =>
  value && value < min ? `Must be at least ${min}` : undefined
const minValue18 = minValue(18)
const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
  'Invalid email address' : undefined
  


const renderTextField = ({
  input, label, meta: { touched, error, warning }, children, select, disabled
}) => (
  <Fragment>
  <ThemeProvider theme={matTheme}>

	  <TextField
	    className="material-form__field"
	    label={label}
	    error={touched && error}
	    value={input.value}
	    children={children}
	    select={select}
	    onChange={(e) => {
	      e.preventDefault();
	      input.onChange(e.target.value);
	    }}
	    variant="outlined"
	    color="#9600BF"
	    disabled={disabled}
	  />
	  {touched && ((error && <div className="field-error">{error}</div>) || (warning && <div className="field-error warn">{warning}</div>))}
	</ThemeProvider>
  </Fragment>
);

renderTextField.propTypes = {
  input: PropTypes.shape().isRequired,
  label: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  select: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.element),
};

renderTextField.defaultProps = {
  label: '',
  meta: null,
  select: false,
  children: [],
};


const renderRichTextEditor = ({
  input, label, meta: { touched, error }, children, select, rows
}) => {
	const editorConfig = {
			readonly: false, // all options from https://xdsoft.net/jodit/doc/
			height:300,
			allowResizeX: false,
			enableDragAndDropFileToEditor: true,
			buttons: [
				'bold',
				'italic',
				'underline',			
				'fontsize',
				'|',
				'link', 'hr', 'align', 
				'|',
				'undo', 'redo'
			],
			buttonsMD: [
				'bold',
				'italic',
				'underline',			
				'fontsize',
				'|',
				'link', 'hr', 'align', 
				'|',
				'undo', 'redo'
			],
			buttonsXS: [
				'bold',
				'italic',
				'underline',			
				'fontsize',
				'|',
				'link', 'hr', 'align', 
				'|',
				'undo', 'redo'
			],
			colorPickerDefaultTab: 'text',
			
	}
	console.log(input)
	return (
		<RichTextEditor
			  value={input.value}
			  onChange={(content) => {
				input.onChange(content);
			  }}	
			  editorConfig={editorConfig}
		/>
   )
}
const ProfileForm = ( props ) => {
	const { handleSubmit, reset, user } = props;
	//console.log(user);
	return(
	  <Row>
	  <Col md={12} lg={12}>
	    <Card className="profile">
	      <CardBody>
	        <div className="card__title">
	          <h5 className="bold-text"><AccountIcon size={36} /> {'Update Profile'}</h5>
	          <div className="page-subhead subhead"></div>
	          <hr/>
	        </div>
	        <form className="material-form" onSubmit={handleSubmit}>
	        <Row>
	        	<Col md={12} lg={12}>
	        	<div className="profile-edit__topbar">
	        	  <Field
		            name="avatar"
		            component={renderDropZoneField}
		          />
		          <div className="topbar__avatar-name">
		          	<h3>{user.firstName} {user.lastName}</h3>
		          	<p className="title">{user.title}</p>
		          	<p className="title">{user.email}</p>
		          </div>
		          </div>
		        </Col>
	        </Row>
	        
	        <Row>
	        	<Col md={12} lg={12} className={"mb-3"}>
		        	<hr/>
		        	<div><strong>Your Profile Information</strong></div>
		        	
		        </Col>
		        <Col md={6} lg={6}>
		          <div>
		            <span className="material-form__label">First Name<sup className="required">*</sup></span>
		            <Field
		              name="firstName"
		              component={renderTextField}
		              placeholder="First Name"
		              validate={[ required ]}
		            />
		          </div>
		        </Col>
		        <Col md={6} lg={6}>
		          <div>
		            <span className="material-form__label">Last Name<sup className="required">*</sup></span>
		            <Field
		              name="lastName"
		              component={renderTextField}
		              placeholder="Last Name"
		              validate={[ required ]}
		            />
		          </div>
		        </Col>
{/*
		        <Col md={6} lg={6}>
		          <div>
		            <span className="material-form__label">Email (Read-only)</span>
		            <Field
		              name="email"
		              component={renderTextField}
		              placeholder="example@mail.com"
		              type="email"
		              validate={email}
		              disabled
		            />
		          </div>
		        </Col>
*/}
		        <Col md={6} lg={6}>
		          <div>
		            <span className="material-form__label">Phone</span>
		            <Field
		              name="primaryPhone"
		              component={renderTextField}
		              placeholder="917-555-1234"
		              type="phone"
		            />
		          </div>
		        </Col>
		         <Col md={6} lg={6}>
		          <div>
		            <span className="material-form__label">Company Name</span>
		            <Field
		              name="company"
		              component={renderTextField}
		              placeholder=""
		              type="text"
		            />
		          </div>
		        </Col>
		         <Col md={6} lg={6}>
		          <div>
		            <span className="material-form__label">Title</span>
		            <Field
		              name="title"
		              component={renderTextField}
		              placeholder="Real Estate Agentt"
		            />
		          </div>
		        </Col>
		        <Col md={6} lg={6}>
		          <div>
		            <span className="material-form__label">NYS Real Estate License #</span>
		            <Field
		              name="agentLicenseNumber"
		              component={renderTextField}
		              placeholder=""
		              type="text"
		            />
		          </div>
		        </Col>
		        <Col md={12} lg={12} className={"mb-3"}>
		        	<hr/>
		        	<div><strong>Company Information</strong></div>
		        	
		        </Col>
				
				<Col md={12} lg={12}>
					<span className="material-form__label">Brand / Logo (Used on shared and exported content)</span>
					
					<div className="mt-2">Upload a dark version of your logo</div>
					<div className="sub-text material-form__label">
						{" "}
						(For best results, use a PNG with a transparent background, 400x100px)
					  </div>
					<div className="profile-edit__topbar">
					  <Field
						name="logo"
						component={renderDropZoneField}
					  />
					  </div>
				</Col>
				
		        <Col md={12} lg={12}>
		          <div>
		            <span className="material-form__label">Address (Ex. 123 Fifth Ave, Suite 111)</span>
		            <Field
		              name="streetAddress"
		              component={renderTextField}
		              placeholder=""
		              type="text"
		            />
		          </div>
		        </Col>
		        <Col md={6} lg={6}>
		          <div>
		            <span className="material-form__label">City</span>
		            <Field
		              name="city"
		              component={renderTextField}
		              placeholder=""
		              type="text"
		            />
		          </div>
		        </Col>
		        <Col md={2} lg={2}>
		          <div>
		            <span className="material-form__label">State (Ex. NY)</span>
		            <Field
		              name="state"
		              component={renderTextField}
		              placeholder=""
		              type="text"
		            />
		          </div>
		        </Col>
		        <Col md={4} lg={4}>
		          <div>
		            <span className="material-form__label">Zip</span>
		            <Field
		              name="zipCode"
		              component={renderTextField}
		              placeholder=""
		              type="text"
		            />
		          </div>
		        </Col>
		       <Col md={12} lg={12} className={"mb-3"}>
				   <hr/>
				   <div><strong>Your Biography</strong></div>
				   
			   </Col>
		        <Col sm={12} md={12} lg={12} xl={12}> 
				  <div>
						 <Field
						  name="biography"
						  component={renderRichTextEditor}
						  placeholder=""
						  multiline
						  rows="2"
						  rowsMax="2"
						/>
					  </div> 
					  <hr/>
				</Col>		        
		        
		        <Col md={12} lg={12}> 
				  <div style={{ position: 'fixed', bottom: 90, right: 100, zIndex: 9999 }}>
				  
					  <Tooltip title={'Save Your Profile'}>
						  <Fab
							  variant="extended"
							  size="medium"
							  color="secondary"
							  aria-label="add"
							  onClick={handleSubmit}
							  style={{marginRight:10, background: '#780F9E' }}
						  >
							<SaveAccountIcon style={{marginRight:5}} /> {' '} Save Profile
						  </Fab>
					  </Tooltip>
					  <Tooltip title={'Reset Changes'}>
							  <Fab
								  variant="extended"
								  size="medium"
								  color="secondary"
								  aria-label="add"
								  onClick={reset}
								  style={{color: '#780F9E', background:"#FFF" }}
							  >
								<ResetAccountIcon  style={{marginRight:5, color: '#780F9E' }} /> Reset
							  </Fab>
						</Tooltip>
				  </div> 
		          {/* <ButtonToolbar className="form__button-toolbar">		           
		             <Tooltip title="Update Profile Information">
				        <Button
					         variant="contained"
					         color="primary"
					         className="primary mr-3"		         
					         startIcon={null}
					         type="submit"
					     >	Save
					     </Button>				 
				  	</Tooltip>
		            <Tooltip title="Discard Changes">
				        <Button
					         onClick={reset}
					         variant="outlined"
					         color=""
					         className=""		         
					         startIcon={null}
					     >	Reset
					     </Button>				 
				  	</Tooltip>{' '}
		           
		          </ButtonToolbar> */}
		        </Col>
	          </Row>
	        </form>
	      </CardBody>
	    </Card>
	  </Col>
	</Row>
	)
};

const form = 'profile_form';

export default connect(
  (state, props) => {
  const initalValues = Object.assign({}, props.user);
  console.log(initalValues, state);
  return {
    initialValues: Object.assign({}, initalValues), // pull initial values from account reducer
    formValues: getFormValues(form)(state),
	
    user: state.user,
  }}
)(reduxForm({
  form: form, // a unique identifier for this form
})(ProfileForm));
